/*
import React from "react";
import ReactGA from "react-ga";
import {withRouter} from "react-router";
import PropTypes from "prop-types";

//const debug = process.env.NODE_ENV === 'development';
ReactGA.initialize([{//Multiple Google Analytics tracking number
  trackingId: 'UA-54854159-9',
  gaOptions: {
    name: 'pedraza',
    userId: 123
  }
}, {
 trackingId: 'UA-112090047-1',
 gaOptions: { name: 'avalon' }
}], { debug: true, alwaysSendToDefaultTracker: false });

class GAListener extends React.Component {

    static contextTypes = {
        router: PropTypes.object
    }

    componentDidMount() {
        this.sendPageView(this.context.router.history.location)
        this.context.router.history.listen(this.sendPageView)
    }

    sendPageView(location) {

        ReactGA.set({ page: location.pathname }, ['pedraza','avalon']);
        ReactGA.pageview(location.pathname,['pedraza','avalon']);

        //if (location.hostname !== 'localhost') {
            const gtag = window.gtag
          //  console.log('in func')
            gtag('config', 'AW-783256938', {
            'page_location': location.href,
            'page_path': location.pathname,
            });
      //  }
    }

    render() {
        return this.props.children
    }
}


export default withRouter(GAListener);

-----------------------*/
import {useEffect} from "react";
import ReactGA from "react-ga";
import {withRouter} from "react-router";
import PropTypes from "prop-types";

const debug = process.env.NODE_ENV === 'development';

function sendPageView(location) {
  ReactGA.set({ page: location.pathname }, ['pedraza','avalon']);
  ReactGA.pageview(location.pathname,['pedraza','avalon']);
  const gtag = window.gtag;
  gtag('config', 'AW-783256938', {
    'page_location': location.href,
    'page_path': location.pathname,
    });
}

function GAListener({children, history}) {
  useEffect(() => {
     if (!debug) {
        ReactGA.initialize([{//Multiple Google Analytics tracking number
          trackingId: 'UA-54854159-9',
          gaOptions: {
            name: 'pedraza',
            userId: 123
          }
        }, {
         trackingId: 'UA-112090047-1',
         gaOptions: { name: 'avalon' }
        }]);
        sendPageView(history.location);
        return history.listen(sendPageView);
      }
  }, [history]);

  return children;
}

GAListener.propTypes = {
  children: PropTypes.node,
  trackingId: PropTypes.string,
  history: PropTypes.shape({
    listen: PropTypes.func,
  }),
};

export default withRouter(GAListener);



// WEBPACK FOOTER //
// ./src/utils/GAListener.js